import { PageBuilderCheckboxPropertiesModel } from '../models/pageBuilderCheckboxPropertiesModel';
import { BaseWidget } from './baseWidget';

export class CheckboxWidget extends BaseWidget<PageBuilderCheckboxPropertiesModel> {
    constructor(checkboxProperties?: Partial<PageBuilderCheckboxPropertiesModel>) {
        super(new PageBuilderCheckboxPropertiesModel(checkboxProperties ?? {}));
    }

    render(): Promise<HTMLElement> {
        const container = this.createContainer();
        const checkbox = this.createCheckbox();
        const label = this.createLabel(checkbox.id);

        container.append(checkbox, label);
        return Promise.resolve(container);
    }

    private createContainer(): HTMLElement {
        const container = document.createElement('div');
        container.classList.add('checkbox-container');
        this.applyStyles(container, {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            width: '100%',
            boxSizing: 'border-box'
        });
        return container;
    }

    private createCheckbox(): HTMLInputElement {
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.required = this.properties.isRequired ?? false;
        checkbox.name = this.properties.labelText?.toLowerCase().replace(/\s+/g, '-') || 'agreement';
        checkbox.classList.add('checkbox-input');
        checkbox.style.cursor = 'pointer';
        checkbox.id = `checkbox-${crypto.getRandomValues(new Uint32Array(1))[0].toString(36)}`;
        return checkbox;
    }

    private createLabel(forId: string): HTMLLabelElement {
        const label = document.createElement('label');
        label.htmlFor = forId;
        label.classList.add('checkbox-label');

        const labelTextProps = this.properties.labelTextProperties ?? {};
        this.applyStyles(label, {
            display: 'flex',
            alignItems: 'center',
            fontFamily: labelTextProps.fontFamily ?? 'Arial, sans-serif',
            fontSize: `${labelTextProps.fontSize ?? 14}px`,
            color: this.formatColor(labelTextProps.color ?? 'FF000000')
        });

        const labelText = this.properties.labelText || 'Ich stimme zu';
        const linkText = this.properties.linkText;
        const linkUrl = this.properties.linkUrl;

        label.innerHTML = linkText && linkUrl
            ? `${labelText} <a href="${linkUrl}" target="_blank" rel="noopener noreferrer" class="checkbox-link">${linkText}</a>`
            : labelText;

        return label;
    }
}